export { mailEventEmitter, MAIL_MODULE_SWITCHER_ICON_CLICKED } from './utils/mailEventEmitters';
